import axios from "axios";
import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem("powerbi_user");
    const verifiedEmail = localStorage.getItem("verified_email");

    if (savedUser) {
      const userData = JSON.parse(savedUser);
      setUser(userData);
      setIsAuthenticated(true);
    } else if (verifiedEmail) {
      const verifiedUser = {
        email: verifiedEmail,
        verified: true,
      };
      setUser(verifiedUser);
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem("powerbi_user", JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem("powerbi_user");
    localStorage.removeItem("verified_email");
    localStorage.removeItem("otp_email");
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem("powerbi_user", JSON.stringify(userData));
  };

  const sendOtp = async (email) => {
    try {
      const res = await axios.post("https://sgoolfoto-backend.onrender.com/api/send-otp", {
        email,
      });
      return res.data;
    } catch (error) {
      // Handle 403 Forbidden - Email not in allowed CSV list
      if (error.response?.status === 403) {
        return {
          success: false,
          error: error.response.data.error || "Dit e-mailadres is niet geautoriseerd. Neem contact op met de beheerder om uw e-mailadres aan het systeem toe te voegen.",
        };
      }

      // Handle other errors
      if (error.response?.data?.error) {
        return {
          success: false,
          error: error.response.data.error,
        };
      }

      // Generic error
      return {
        success: false,
        error: "Verzenden van OTP mislukt. Probeer het opnieuw.",
      };
    }
  };

  const verifyOtp = async (email, otp) => {
    const res = await axios.post("https://sgoolfoto-backend.onrender.com/api/verify-otp", {
      email,
      otp,
    });

    if (res.data.success) {
      localStorage.setItem("verified_email", email);

      const roles = Array.isArray(res.data.roles) && res.data.roles.length > 0
        ? res.data.roles
        : ["Fotograaf"];

      const verifiedUser = {
        email: email,
        username: email,
        verified: true,
        roles,
        organizationName: email.split("@")[1] || "Organization",
        loginTime: new Date().toISOString(),
      };
      setUser(verifiedUser);
      setIsAuthenticated(true);
      localStorage.setItem("powerbi_user", JSON.stringify(verifiedUser));
    }

    return res.data;
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        loading,
        login,
        logout,
        updateUser,
        sendOtp,
        verifyOtp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};
